import { ButtonLink, ButtonLinkProps, Stack } from 'component-library';
import { cn } from 'component-library/utils';
import { HTMLAttributes, ReactNode } from 'react';

export type TileProps = {
  chart: ReactNode;
  title: ReactNode;
  capsuleContent: ReactNode;
  cta: ReactNode;
};

export const Tile = ({ chart, capsuleContent, cta, title }: TileProps) => {
  return (
    <Stack spacing={4} className='h-[300px] justify-between'>
      <Stack spacing={2}>
        {title}
        {capsuleContent}
      </Stack>
      {chart}
      <Stack spacing={4} className='items-start'>
        {cta}
      </Stack>
    </Stack>
  );
};

export const TileCapsuleTitle = ({ className, ...delegated }: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('typography-overline text-text-secondary', className)} {...delegated} />;
};

export const TileTitle = ({ className, ...delegated }: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('typography-overline font-semibold text-text-secondary', className)} {...delegated} />;
};

export const TileCapsuleContent = ({ className, ...delegated }: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('typography-h3', className)} {...delegated} />;
};

export const TileCta = (props: ButtonLinkProps) => {
  return <ButtonLink variant='outline' {...props} />;
};

export const TileHelper = ({ className, ...delegated }: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('typography-caption text-text-secondary', className)} {...delegated} />;
};
